module.exports = {
  getJSONFromURL: (url) => {
    if(!url) url = window.location.search;
    let query = url;
    let result = {};
    query.split("&").forEach(function(part) {
      let item = part.split("=");
      result[item[0]] = decodeURIComponent(item[1]);
    });
    return result;
  },

  formatDate: (date) => {
    let d = new Date(date),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear();

    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;

    return [year, month, day].join('-');
  },

  itemConstructor: (item, field) => {
    if(!field.includes(".")) return item[field]
    let fields = field.split(".");
    return item[fields[0]][fields[1]];
  },

  options: [
    {key: 'BANK TRANSACTIONS', text: 'Bank transactions', value: 'createMultipleCSVBankTransactions'},
    {key: 'CREDIT NOTES', text:'Credit Notes', value: 'createMultipleCSVCreditNotes'},
    {key: 'INVOICES', text: 'Invoices', value: 'createMultipleCSVInvoices'},
    {key: 'JOURNALS', text: 'Journals', value: 'createMultipleCSVJournals'},
    {key: 'MANUAL JOURNALS', text: 'Manual journals', value: 'createMultipleCSVManualJournals'},
    {key: 'ORGANISATIONS', text: 'Organisations', value: 'createMultipleCSVOrganisations'},
    {key: 'PAYMENTS', text: 'Payments', value: 'createMultipleCSVPayments'},
  ],

  TABLE_HEADERS: {
    bank_transactions: {
      headers: ["Contact", "Account", "Reference", "Type", "Subtotal", "Total tax",  "Status"],
      fields: ["Contact.Name", "BankAccount.Name", "Reference", "Type", "SubTotal", "TotalTax", "Status"],
      key: "BankTransactionID"
    },
    credit_notes: {
      headers: ["Credit Note Number", "Contact", "Date", "Subtotal", "Total tax", "Total", "Status"],
      fields: ["CreditNoteNumber", "Contact.Name", "DateString", "SubTotal", "TotalTax", "Total", "Status"],
      key: "CreditNoteID",
    },
    invoices: {
      headers: ["Contact", "Type", "Invoice Number", "Reference", "Amount Due", "Amount Paid", "Status"],
      fields: ["Contact.Name", "Type", "InvoiceNumber", "Reference", "AmountDue", "AmountPaid", "Status"],
      key: "InvoiceID"
    },
    journals: {
      headers: ["Journal Number", "Journal Date", "Source Type", "Created Date"],
      fields: ["JournalNumber", "JournalDate", "SourceType", "CreatedDateUTC"],
      key: "JournalID",
    },
    manual_journals: {
      headers: ["Date", "Updated Date", "Narration", "Status"],
      fields: ["Date", "UpdatedDateUTC", "Narration", "Status"],
      key: "ManualJournalID",
    },
    payments: {
      headers: ["Reference", "Account Code", "Amount", "Status"],
      fields: ["Reference", "Account.Code", "Amount", "Status"],
      key: "PaymentID"
    },
    organisations: {
      headers: ["Legal Name", "Type", "Edition", "Status"],
      fields: ["LegalName", "OrganisationType", "Edition", "OrganisationStatus"],
      key: "OrganisationID"
    }
  }
}